import { createAction } from 'actions/utils'

export const UPDATE_XMC_MODULE_NAME = 'UPDATE_XMC_MODULE_NAME'
export const updateXmcModuleName = createAction(UPDATE_XMC_MODULE_NAME, [
  'moduleName',
  'featureId',
])

export const SET_FEATURE_FIELD = 'SET_FEATURE_FIELD'
export const setFeatureField = (paramName, value, featureId) => ({
  type: SET_FEATURE_FIELD,
  paramName,
  value,
  featureId,
})

const RESET_CURRENT_FEATURE_METADATA = 'RESET_CURRENT_FEATURE_METADATA'
export const resetCurrentFeatureMetadata = createAction(
  RESET_CURRENT_FEATURE_METADATA,
  ['featureId']
)
